import { TextField, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import HomeIcon from "@material-ui/icons/Home";

const OrdersHeader = ({ onSearchTermFilterChange }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const history = useHistory();

  const goToHome = () => {
    history.push("/home");
  };

  return (
    <header className="bg-white shadow-sm z-10">
      <div className="p-4">
        <div className="flex items-center justify-between mb-4">
          <>
            <div className="flex items-center gap-4">
              <HomeIcon className=" mr-3 cursor-pointer" onClick={goToHome} />
              <Typography
                className="text-2xl font-semibold text-slate-800"
                style={{ borderLeft: "1px solid #c4c4c4", paddingLeft: 20 }}
              >
                Orders
              </Typography>
            </div>
          </>

          <TextField
            label="Search Orders"
            variant="outlined"
            size="small"
            placeholder={"Search Orders..."}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onSearchTermFilterChange(e.target.value);
              }
            }}
          />
        </div>
      </div>
    </header>
  );
};

export default OrdersHeader;
